import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3 } from '../../../../graphql/Catalog/Groups/groupsCategories'
import { SUBJURISDICTIONS_TO_GROUPS_CATEGORIES_SUB } from '../../../../graphql/Catalog/Jurisdictions/jurisdictionSub'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'

const ZonesModal = ({ id, refModal, initialIds }) => {
  const [selectedIds, setSelectedIds] = useState([])

  const { data } = useQuery(
    GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3,
    {
      variables: { groupId: 1 },
      fetchPolicy: 'no-cache',
    }
  )
  const [submitSubJurisdictions] = useMutation(
    SUBJURISDICTIONS_TO_GROUPS_CATEGORIES_SUB
  )

  useEffect(() => {
    if (initialIds) setSelectedIds(initialIds)
  }, [initialIds])

  const handleCheckboxChange = useCallback((subCategoryId) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(subCategoryId)
        ? prevSelectedIds.filter((id) => id !== subCategoryId)
        : [...prevSelectedIds, subCategoryId]
    )
  }, [])

  const handleSubmit = useCallback(async () => {
    await submitSubJurisdictions({
      variables: {
        subJurisdictionId: id,
        categoriesSubIds: selectedIds,
      },
    })
    return toastSweetAlert({
        mode: 'okToast',
        message: 'Subcategorias asignadas correctamente',
    }),refModal.current.click()
  }, [id, selectedIds, submitSubJurisdictions, refModal])

  const categories = useMemo(() => data?.getAllGroupsCategoriesAndSubsByGroupIdQuery || [], [data])

  return (
    <div id="accordion" className="jurisdiction-sub-modal">
      {categories.map((category) => (
        <div className="card" key={category.id}>
          <div className="card-header" id={`heading${category.id}`}>
            <h3>
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target={`#collapse${category.id}`}
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {category.name}
              </button>
            </h3>
          </div>

          <div
            id={`collapse${category.id}`}
            className="collapse"
            aria-labelledby={`heading${category.id}`}
            data-parent="#accordion"
          >
            <div className="card-body">
              {category.subs.map((sub) => (
                <div key={sub.id}>
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(sub.id)}
                      onChange={() => handleCheckboxChange(sub.id)}
                    />
                    {sub.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      <button className="btn btn-sm btn-migrates" onClick={handleSubmit}>
        Submit
      </button>
    </div>
  )
}

export default ZonesModal
